import type { GitFileTree, GitTreeItem } from '../models/git-worker.model';

export function treeToArray(tree: GitFileTree): GitTreeItem[] {
  return Object.values(tree)
    .map((treeItem) => unpackTreeItemChildren(treeItem))
    .flat(Number.MAX_VALUE) as GitTreeItem[];
}

function unpackTreeItemChildren(treeItem: GitTreeItem): GitTreeItem[] {
  if (treeItem.children) {
    return Object.values(treeItem.children)
      .map((treeItemChild) => unpackTreeItemChildren(treeItemChild))
      .flat();
  }

  return [treeItem];
}
